export default __webpack_public_path__ + "static/static2-img-d965dd57ca2b5298e28b9f740181611f.jpg";